export const layerState  = ({commit, state, rootState}, layer) => {
  let walk = (node) => {
    if (node['children']) {
      node['children'].forEach(n => walk(n))
      return
    }
    if (node['id'] === layer['id']) {
      for (let k in layer) {
        node[k] = layer[k]
      }
    }
  }

  let tree = [...state.layersTree]
  tree.forEach(walk)
  commit('layerTreeUpdate', tree)
}

export const layerPosition  = ({commit, state, rootState}, data) => {
  let {layerId, oldPos, newPos, isRoot} = data;
  let tree = [...state.layersTree]
  let flip = (arr, o, n) => {
    let tmp = arr[n]
    arr[n] = arr[o]
    arr[o] = tmp
  }

  if (isRoot) {
    flip(tree, oldPos, newPos)
  } else {
    tree.forEach(t => {
      if (t.children && t.children.filter(c => c['id'] === layerId).length > 0) {
        flip(t.children, oldPos, newPos)
      }
    })
  }
  commit('layerTreeUpdate', tree)
}



// WEBPACK FOOTER //
// ./src/store/modules/map/actions.js